<template>
	<div id="articlePushManage" style="background-color: #F0F0F0;">
  &nbsp;
		  <!--搜索下拉列表区域-->
  <div class="pushPageAllSearch">
	<div style="height: 70px">
        <ul>
          <li>
            <span>领域:</span> 
            <select @change="changeSelect($event)"  class="pushPageSelect" v-model="cateModel.dategoryId">
                      <option :key="index" v-for="(childrenitem, index) in allCategory" :value="childrenitem.id" selected>{{childrenitem.name}}</option>
            </select>
            &nbsp;&nbsp;&nbsp;
            <span>产品:</span>
            <select @change="changeSelect($event)" class="pushPageSelect" v-model="cateModel.productId">
                <option :key="index" v-for="(childrenitem, index) in allProduct" :value="childrenitem.id" selected>{{childrenitem.name}}</option>
            </select>
		      </li>
          <li style="margin-top:10px;">
			      <span>标题:</span> 
            <input @keyup.enter="inputDataEvent()" class="allInputmycustom" style="width: 318px;" placeholder="请输入标题" v-model="inputData"/>
		      </li>
      </ul>
      </div>
  </div>
  <div style="margin-top: 10px;background-color:#FFFFFF;text-align:center;border-radius: 10px 10px 10px 10px;margin-left: 10px;margin-right: 10px;" 
  	:key="index" v-for="(item, index) in allArticleInfo" >
        <table cellspacing="5" style="height:80px;">
          <tbody>
          <tr>
            <th colspan="2" style="text-align: left;width: 510px;"><font size="3">{{item.title}}</font></th>
            <td colspan="2" rowspan="2"><button @click="articalPush(item)" style="background: red; color: #fff;border: none;width: 75px;height: 28px;font-size:0.675rem" >确认发送</button></td>
          </tr>
          <tr>
            <td style="text-align: left;width: 240px;background-color:#FFFFFF;"><font size="2">{{item.categoryName}}</font></td>
            <td style="text-align: left;width: 270px;background-color:#FFFFFF;">
              <i class="icon iconfont iconcalendar" style="color: rgb(137,137,137);"></i>
              <font size="2">{{item.creationTime}}</font>
            </td>
          </tr>
          </tbody>
        </table>
      </div>
</div>


</template>

<script>
export default {
  name: 'articlePushManage',
  data () {
    return {
      allProduct: [
				{
				id: '-1',
				name: '全部'
				}
			],
      allCategory: [
				{
				id: '-1',
				name: '全部'
				}
			],
      allArticleInfo: [],
      cateModel: {
				dategoryId: '-1',
				productId: '-1'
      },
      inputData: '',
      addPushStatus: ''
    }
  },
  created () {
    this.getAllProduct()
    this.getAllCategory()
    this.getArticleInfo()
    this.getAllDoc()
  },
  methods: {
    getAllProduct () {
      		this.$axiox.get('/api/wechat/ArticlePush/querySelProduct').then(p => {
        		this.allProduct = p
      		})
		},
    getAllCategory () {
      		this.$axiox.get('/api/wechat/ArticlePush/queryCategoryName').then(p => {
        		this.allCategory = p
      		})
		},
    getArticleInfo () {
      		this.$axiox.get('/api/wechat/ArticlePush/searchArticleInfo').then(p => {
        		this.allArticleInfo = p
      		})
          let brand = '';
          for (let i = 0; i < this.allArticleInfo.length; i++) {
            brand = brand + this.allArticleInfo[i].brandCode;
          }
          let list;
          let index = 0;
          for (let j = 0; j < this.allProduct.length; j++) {
            if (j === 0) {
              list[index] = this.allProduct[j]
              index = 1
            } else {
              if (brand.indexOf(this.allProduct[j].id) >= 0) {
                list[index] = this.allProduct[j]
                index++
              }
            }
          }
          this.allProduct = list
		},
    changeSelect (event) {
			var dategory = this.cateModel.dategoryId
			var prd = this.cateModel.productId
      var input = this.inputData
			this.$axiox.get('/api/wechat/ArticlePush/searchArticleInfo').then(p => {
        this.allArticleInfo = p
				if (dategory !== '-1') {
					this.allArticleInfo = this.allArticleInfo.filter(val => val.categoryName.indexOf(dategory) > -1)
				}
				if (prd !== '-1') {
					this.allArticleInfo = this.allArticleInfo.filter(val => val.brandCode.indexOf(prd) > -1)
				}
        if (input !== '') {
					this.allArticleInfo = this.allArticleInfo.filter(val => val.title.indexOf(input) > -1)
				}
      })
    },
    inputDataEvent () {
			var dategory = this.cateModel.dategoryId
			var prd = this.cateModel.productId
      var input = this.inputData
			this.$axiox.get('/api/wechat/ArticlePush/searchArticleInfo').then(p => {
        this.allArticleInfo = p
				if (dategory !== '-1') {
					this.allArticleInfo = this.allArticleInfo.filter(val => val.categoryName.indexOf(dategory) > -1)
				}
				if (prd !== '-1') {
					this.allArticleInfo = this.allArticleInfo.filter(val => val.brandCode.indexOf(prd) > -1)
				}
        if (input !== '') {
					this.allArticleInfo = this.allArticleInfo.filter(val => val.title.indexOf(input) > -1)
				}
      })
    },
    articalPush(object) {
      let docCode1 = window.localStorage.getItem('DocCode')
      let docName1 = window.localStorage.getItem('DocName')
      let docOpenId1 = window.localStorage.getItem('DocOpenId')
      let data = {
        code: docCode1,
        name: docName1,
        openid: docOpenId1,
        articleid: object.id
      }
      this.$axiox.post('/api/wechat/ArticlePush/addArticlePushFormHCP', data).then(p => {
        this.$commonJs.alertTipsMycustom({
          type: 'success',
          title: '成功',
          content: '推送成功',
          stayTime: 2
        })
      })
		}
  }
}
</script>



// WEBPACK FOOTER //
// src/components/login/articlePushManage.vue